/* eslint-disable */
import { propsDecorator } from '@/js/common/Domain/Service/mixins/decorators';
import DirectionsRepository from "@/js/common/Domain/Repository/Directions";
import _ from 'underscore';

var directionsLimit = 9;

@propsDecorator({
    defaults: {
        selectedRestType: null,
        showAll: false,
        directions: null,
    },
    computeds: {
        filteredDirections() {
            const allDirections = this.get('directions');
            const selectedResortType = this.get('selectedRestType');
            const filteredDirections = [];

            if (selectedResortType !== null) {
                allDirections.each((direction) => {
                    const restTypes = direction.get('restTypes');

                    if (!_.isEmpty(restTypes) && !!~restTypes.indexOf(selectedResortType)) {
                        filteredDirections.push(direction);
                    }
                });

                return new DirectionsRepository(filteredDirections);
            }

            return allDirections;
        },
        filteredDirectionsWithShowAll() {
            const filteredDirections = this.get('filteredDirections');
            const showAll = this.get('showAll');

            if (!_.isEmpty(filteredDirections)) {
                if (!showAll) {
                    return new DirectionsRepository(filteredDirections.slice(0, directionsLimit));
                }

                return new DirectionsRepository(filteredDirections.models);
            }

            return [];
        },
        selectedRestTypeName() {
            const selectedRestType = this.get('selectedRestType');

            return selectedRestType?.get('name') || 'Популярные направления';
        },
        showMoreButtonVisible() {
            const filteredDirections = this.get('filteredDirections');

            if (filteredDirections?.length > directionsLimit) {
                return true;
            }

            return false;
        },
        restTypesCount() {
            const directions = this.get('directions');

            if (!directions?.length) {
                return null;
            }

            const allRestTypes = directions.reduce((restTypes, direction) => {
                const restType = direction.get('restTypes');

                if (!_.isEmpty(restType)) {
                    restTypes = restTypes.concat(restType.pluck('id'));
                }

                return restTypes;
            }, []);

            return _.countBy(allRestTypes, (hotelTypeId) => hotelTypeId);
        },
    },
})
export default class ToursOnIndexModel extends Backbone.Epoxy.Model {
    selectedRestTypeChanged() {
        this.set('showAll', false);
    }

    initialize() {
        this.on('change:selectedRestType', this.selectedRestTypeChanged.bind(this));
    }
}
